<app-modal
  #modal
  [modalConfig]="{
    headerClass: ['visually-hidden'],
    options: { size: 'lg' }
  }">
  <app-user-select (selectedUser)="chooseUser($event)"></app-user-select>
</app-modal>
